import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <section className="mx-auto max-w-xl px-5 sm:px-8 py-24" data-testid="payment-cancel-page">
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
        <XCircle className="text-slate-500" size={22} />
        <h1 className="mt-4 font-heading text-2xl font-semibold tracking-tight">No payment taken</h1>
        <p className="mt-2 text-sm text-slate-600">
          Your booking was not confirmed because payment was not completed.
        </p>
        <p className="mt-3 text-xs leading-5 text-slate-500" data-testid="payment-cancel-legal-note">
          Payments and invoices are processed by FONDO ehf., operator of IceFleet.
        </p>
        {bookingId && <p className="mt-2 text-xs text-slate-400">Booking ref: {bookingId}</p>}
        <div className="mt-6 flex gap-3">
          <Link to="/" className="inline-flex items-center gap-1.5 rounded-md bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate-800"><ArrowLeft size={14}/> Home</Link>
          <Link to="/contact" className="rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
